// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  
.Login_container__2pcnf {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    margin: 0; 
    padding: 0;
    background: linear-gradient(135deg, #48027796, #005eff);
    font-family: 'Arial', sans-serif;
}


.Login_card__IRduH {
    background: #ffffff;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}

.Login_title__jk6Rr {
    font-size: 2rem;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 1.5rem;
}

.Login_form__VvZSV {
    display: flex;
    flex-direction: column;
    align-items: stretch; /* Ustaw elementy na pełną szerokość */
    width: 100%; /* Formularz zajmuje całą szerokość kontenera */
    max-width: 300px; /* Ogranicz maksymalną szerokość formularza */
    margin: 0 auto; /* Wyśrodkuj formularz */
    padding: 0 1rem; /* Dodaj wewnętrzny odstęp, aby formularz nie dotykał krawędzi */
}

.Login_inputGroup__epVR0 {
    width: 100%; /* Ustaw szerokość grupy wejściowej */
    margin-bottom: 1rem; /* Dodaj odstęp między polami */
    text-align: left; /* Wyrównaj tekst do lewej */
}

.Login_label__zlJQ- {
    font-size: 0.9rem;
    color: #555555;
    margin-bottom: 0.5rem;
    display: block;
    text-align: left; /* Wyrównanie tekstu do lewej */
}

.Login_input__ADhfa {
    width: 100%; /* Pole wejściowe zajmuje całą szerokość grupy */
    padding: 0.8rem;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s ease;
    box-sizing: border-box; /* Upewnij się, że padding nie wpływa na szerokość */
}

.Login_input__ADhfa:focus {
    border-color: #2575fc;
}

.Login_button__86uwc {
    background: #2575fc;
    color: #ffffff;
    padding: 0.8rem;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.3s ease;
    width: 100%; /* Przycisk zajmuje całą szerokość formularza */
}

.Login_button__86uwc:hover {
    background: #1a5bb8;
}

.Login_languageFlags__fcI-j {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 10px;
}

.Login_languageFlags__fcI-j .Login_fi__1blVn {
    font-size: 24px;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.Login_languageFlags__fcI-j .Login_fi__1blVn:hover {
    opacity: 1;
    transform: scale(1.1);
}

.Login_activeFlag__MPKqr {
    opacity: 1;
    border: 2px solid #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/Login.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;;AAGF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,uDAAuD;IACvD,gCAAgC;AACpC;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAE,sCAAsC;IAC5D,WAAW,EAAE,+CAA+C;IAC5D,gBAAgB,EAAE,6CAA6C;IAC/D,cAAc,EAAE,wBAAwB;IACxC,eAAe,EAAE,gEAAgE;AACrF;;AAEA;IACI,WAAW,EAAE,qCAAqC;IAClD,mBAAmB,EAAE,+BAA+B;IACpD,gBAAgB,EAAE,4BAA4B;AAClD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA;IACI,WAAW,EAAE,gDAAgD;IAC7D,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kCAAkC;IAClC,sBAAsB,EAAE,oDAAoD;AAChF;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,WAAW,EAAE,+CAA+C;AAChE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  \r\n.container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    margin: 0; \r\n    padding: 0;\r\n    background: linear-gradient(135deg, #48027796, #005eff);\r\n    font-family: 'Arial', sans-serif;\r\n}\r\n\r\n\r\n.card {\r\n    background: #ffffff;\r\n    padding: 2rem;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    width: 100%;\r\n    max-width: 400px;\r\n}\r\n\r\n.title {\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n    color: #333333;\r\n    text-align: center;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch; /* Ustaw elementy na pełną szerokość */\r\n    width: 100%; /* Formularz zajmuje całą szerokość kontenera */\r\n    max-width: 300px; /* Ogranicz maksymalną szerokość formularza */\r\n    margin: 0 auto; /* Wyśrodkuj formularz */\r\n    padding: 0 1rem; /* Dodaj wewnętrzny odstęp, aby formularz nie dotykał krawędzi */\r\n}\r\n\r\n.inputGroup {\r\n    width: 100%; /* Ustaw szerokość grupy wejściowej */\r\n    margin-bottom: 1rem; /* Dodaj odstęp między polami */\r\n    text-align: left; /* Wyrównaj tekst do lewej */\r\n}\r\n\r\n.label {\r\n    font-size: 0.9rem;\r\n    color: #555555;\r\n    margin-bottom: 0.5rem;\r\n    display: block;\r\n    text-align: left; /* Wyrównanie tekstu do lewej */\r\n}\r\n\r\n.input {\r\n    width: 100%; /* Pole wejściowe zajmuje całą szerokość grupy */\r\n    padding: 0.8rem;\r\n    border: 1px solid #cccccc;\r\n    border-radius: 5px;\r\n    font-size: 1rem;\r\n    outline: none;\r\n    transition: border-color 0.3s ease;\r\n    box-sizing: border-box; /* Upewnij się, że padding nie wpływa na szerokość */\r\n}\r\n\r\n.input:focus {\r\n    border-color: #2575fc;\r\n}\r\n\r\n.button {\r\n    background: #2575fc;\r\n    color: #ffffff;\r\n    padding: 0.8rem;\r\n    border: none;\r\n    border-radius: 5px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease;\r\n    width: 100%; /* Przycisk zajmuje całą szerokość formularza */\r\n}\r\n\r\n.button:hover {\r\n    background: #1a5bb8;\r\n}\r\n\r\n.languageFlags {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.languageFlags .fi {\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n    transition: opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.languageFlags .fi:hover {\r\n    opacity: 1;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.activeFlag {\r\n    opacity: 1;\r\n    border: 2px solid #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__2pcnf`,
	"card": `Login_card__IRduH`,
	"title": `Login_title__jk6Rr`,
	"form": `Login_form__VvZSV`,
	"inputGroup": `Login_inputGroup__epVR0`,
	"label": `Login_label__zlJQ-`,
	"input": `Login_input__ADhfa`,
	"button": `Login_button__86uwc`,
	"languageFlags": `Login_languageFlags__fcI-j`,
	"fi": `Login_fi__1blVn`,
	"activeFlag": `Login_activeFlag__MPKqr`
};
export default ___CSS_LOADER_EXPORT___;
